import { graphql } from '@/graphql-setup'

export const WORK_DAY_INFRINGEMENT_QUERY = graphql(`
  query WorkDayInfringement($id: ID!) {
    workDayInfringement(id: $id) {
      id
      createdAt
      reasonValue
      secondaryReasonValue
      periodStartDate
      periodEndDate
      infringementTimestamp
      archivedAt
      closedAt
      archivedBasis
      wronglyGenerated
      wronglyGeneratedExplanation
      solution
      leadersComment
      user {
        id
        fullName
        phoneNumber
      }
      workInfringementCategory {
        id
        identifier
        title
        description
        legalBasis
      }
      attachments {
        id
        name
        file
      }
      actionLogs {
        id
        action
        attachmentName
        createdAt
        user {
          id
          fullName
        }
      }
      segments {
        id
        segmentType
        datetimeStart
        datetimeEnd
      }
    }
  }
`)
